import propertyModel from './models/_property_model'

var bz_app = angular
  .module(
    'bz_app',
    [
      'bzYelpModule',
      'bzFormModule',
      'bzPotentialLeadFormModule',
      'bzMapModule',
      'bzDataApplicationModule',
    ].concat(defaultAngularModuleSet)
  )
  .factory('propertyModel', propertyModel)
  .run([
    function () {
      const referralSource = getURLParameter('referral_source')
      const triggerReferralSources = ['internachi', 'top-agent']

      setTimeout(() => {
        if (
          referralSource &&
          triggerReferralSources.includes(referralSource) &&
          $('.data-subscription-trigger').length
        ) {
          let dataModalTrigger = $('.data-subscription-trigger').first()
          dataModalTrigger.attr('referral-source', referralSource)
          dataModalTrigger.click()
        }
      }, 300)
    },
  ])

angular.element(document).ready(function () {
  angular.bootstrap(document, ['bz_app'])
})
window.bz_app = bz_app
